import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackSubmittedCollectionForm.meta';

export type TrackSubmittedCollectionFormParams = {
  auto_submit: boolean;
};

export const useTrackSubmittedCollectionForm = () => {
  const { track } = useAnalyticsUtilities();

  const trackSubmittedCollectionForm = useCallback(
    (params: TrackSubmittedCollectionFormParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackSubmittedCollectionForm };
};
